export enum FilesMainKind {
  OTHER = 'other',
  PROOF_OF_ID = 'proof_of_id',
  PROOF_OF_RESIDENCE = 'proof_of_residence',
  PROOF_OF_WORK = 'proof_of_work',
  PROOF_OF_REVENUE = 'proof_of_revenue',
  TAX_NOTICE = 'tax_notice',
}

export const MainKindTranslate: { [key in FilesMainKind]: string } = {
  [FilesMainKind.OTHER]: 'Autres',
  [FilesMainKind.PROOF_OF_ID]: "Justificatif d'identité",
  [FilesMainKind.PROOF_OF_RESIDENCE]: 'Justificatif(s) de domicile',
  [FilesMainKind.PROOF_OF_WORK]: "Justificatif d'activité professionnelle",
  [FilesMainKind.PROOF_OF_REVENUE]: 'Justificatif(s) de revenus',
  [FilesMainKind.TAX_NOTICE]: "Avis d'imposition",
}
